// @generated from time-data-gen.ts
// prettier-ignore  
export var timeData = {
  "AX": ["H"],
  "BQ": ["H"],
  "CP": ["H"],
  "CZ": ["H"],
  "DK": ["H"],
  "FI": ["H"],
  "ID": ["H"],
  "IS": ["H"],
  "ML": ["H"],
  "NE": ["H"],
  "RU": ["H"],
  "SE": ["H"],
  "SJ": ["H"],
  "SK": ["H"],
  "AS": ["h", "H"],
  "BT": ["h", "H"],
  "DJ": ["h", "H"],
  "ER": ["h", "H"],
  "GH": ["h", "H"],
  "IN": ["h", "H"],
  "LS": ["h", "H"],
  "PG": ["h", "H"],
  "PW": ["h", "H"],
  "SO": ["h", "H"],
  "TO": ["h", "H"],
  "VU": ["h", "H"],
  "WS": ["h", "H"],
  "001": ["H", "h"],
  "AL": ["h", "H", "hB"],
  "TD": ["h", "H", "hB"],
  "ca-ES": ["H", "h", "hB"],
  "CF": ["H", "h", "hB"],
  "CM": ["H", "h", "hB"],
  "fr-CA": ["H", "h", "hB"],
  "gl-ES": ["H", "h", "hB"],
  "it-CH": ["H", "h", "hB"],
  "it-IT": ["H", "h", "hB"],
  "LU": ["H", "h", "hB"],
  "NP": ["H", "h", "hB"],
  "PF": ["H", "h", "hB"],
  "SC": ["H", "h", "hB"],
  "SM": ["H", "h", "hB"],
  "SN": ["H", "h", "hB"],
  "TF": ["H", "h", "hB"],
  "VA": ["H", "h", "hB"],
  "CY": ["h", "H", "hb", "hB"],
  "GR": ["h", "H", "hb", "hB"],
  "CO": ["h", "H", "hB", "hb"],
  "DO": ["h", "H", "hB", "hb"],
  "KP": ["h", "H", "hB", "hb"],
  "KR": ["h", "H", "hB", "hb"],
  "NA": ["h", "H", "hB", "hb"],
  "PA": ["h", "H", "hB", "hb"],
  "PR": ["h", "H", "hB", "hb"],
  "VE": ["h", "H", "hB", "hb"],
  "AC": ["H", "h", "hb", "hB"],
  "AI": ["H", "h", "hb", "hB"],
  "BW": ["H", "h", "hb", "hB"],
  "BZ": ["H", "h", "hb", "hB"],
  "CC": ["H", "h", "hb", "hB"],
  "CK": ["H", "h", "hb", "hB"],
  "CX": ["H", "h", "hb", "hB"],
  "DG": ["H", "h", "hb", "hB"],
  "FK": ["H", "h", "hb", "hB"],
  "GB": ["H", "h", "hb", "hB"],
  "GG": ["H", "h", "hb", "hB"],
  "GI": ["H", "h", "hb", "hB"],
  "IE": ["H", "h", "hb", "hB"],
  "IM": ["H", "h", "hb", "hB"],
  "IO": ["H", "h", "hb", "hB"],
  "JE": ["H", "h", "hb", "hB"],
  "LT": ["H", "h", "hb", "hB"],
  "MK": ["H", "h", "hb", "hB"],
  "MN": ["H", "h", "hb", "hB"],
  "MS": ["H", "h", "hb", "hB"],
  "NF": ["H", "h", "hb", "hB"],
  "NG": ["H", "h", "hb", "hB"],
  "NR": ["H", "h", "hb", "hB"],
  "NU": ["H", "h", "hb", "hB"],
  "PN": ["H", "h", "hb", "hB"],
  "SH": ["H", "h", "hb", "hB"],
  "SX": ["H", "h", "hb", "hB"],
  "TA": ["H", "h", "hb", "hB"],
  "ZA": ["H", "h", "hb", "hB"],
  "af-ZA": ["H", "h", "hB", "hb"],
  "AR": ["H", "h", "hB", "hb"],
  "CL": ["H", "h", "hB", "hb"],
  "CR": ["H", "h", "hB", "hb"],
  "CU": ["H", "h", "hB", "hb"],
  "EA": ["H", "h", "hB", "hb"],
  "es-BO": ["H", "h", "hB", "hb"],
  "es-BR": ["H", "h", "hB", "hb"],
  "es-EC": ["H", "h", "hB", "hb"],
  "es-ES": ["H", "h", "hB", "hb"],
  "es-GQ": ["H", "h", "hB", "hb"],
  "es-PE": ["H", "h", "hB", "hb"],
  "GT": ["H", "h", "hB", "hb"],
  "HN": ["H", "h", "hB", "hb"],
  "IC": ["H", "h", "hB", "hb"],
  "KG": ["H", "h", "hB", "hb"],
  "KM": ["H", "h", "hB", "hb"],
  "LK": ["H", "h", "hB", "hb"],
  "MA": ["H", "h", "hB", "hb"],
  "MX": ["H", "h", "hB", "hb"],
  "NI": ["H", "h", "hB", "hb"],
  "PY": ["H", "h", "hB", "hb"],
  "SV": ["H", "h", "hB", "hb"],
  "UY": ["H", "h", "hB", "hb"],
  "JP": ["H", "h", "K"],
  "AD": ["H", "hB"],
  "AM": ["H", "hB"],
  "AO": ["H", "hB"],
  "AT": ["H", "hB"],
  "AW": ["H", "hB"],
  "BE": ["H", "hB"],
  "BF": ["H", "hB"],
  "BJ": ["H", "hB"],
  "BL": ["H", "hB"],
  "BR": ["H", "hB"],
  "CG": ["H", "hB"],
  "CI": ["H", "hB"],
  "CV": ["H", "hB"],
  "DE": ["H", "hB"],
  "EE": ["H", "hB"],
  "FR": ["H", "hB"],
  "GA": ["H", "hB"],
  "GF": ["H", "hB"],
  "GN": ["H", "hB"],
  "GP": ["H", "hB"],
  "GW": ["H", "hB"],
  "HR": ["H", "hB"],
  "IL": ["H", "hB"],
  "IT": ["H", "hB"],
  "KZ": ["H", "hB"],
  "MC": ["H", "hB"],
  "MD": ["H", "hB"],
  "MF": ["H", "hB"],
  "MQ": ["H", "hB"],
  "MZ": ["H", "hB"],
  "NC": ["H", "hB"],
  "NL": ["H", "hB"],
  "PM": ["H", "hB"],
  "PT": ["H", "hB"],
  "RE": ["H", "hB"],
  "RO": ["H", "hB"],
  "SI": ["H", "hB"],
  "SR": ["H", "hB"],
  "ST": ["H", "hB"],
  "TG": ["H", "hB"],
  "TR": ["H", "hB"],
  "WF": ["H", "hB"],
  "YT": ["H", "hB"],
  "BD": ["h", "hB", "H"],
  "PK": ["h", "hB", "H"],
  "AZ": ["H", "hB", "h"],
  "BA": ["H", "hB", "h"],
  "BG": ["H", "hB", "h"],
  "CH": ["H", "hB", "h"],
  "GE": ["H", "hB", "h"],
  "LI": ["H", "hB", "h"],
  "ME": ["H", "hB", "h"],
  "RS": ["H", "hB", "h"],
  "UA": ["H", "hB", "h"],
  "UZ": ["H", "hB", "h"],
  "XK": ["H", "hB", "h"],
  "AG": ["h", "hb", "H", "hB"],
  "AU": ["h", "hb", "H", "hB"],
  "BB": ["h", "hb", "H", "hB"],
  "BM": ["h", "hb", "H", "hB"],
  "BS": ["h", "hb", "H", "hB"],
  "CA": ["h", "hb", "H", "hB"],
  "DM": ["h", "hb", "H", "hB"],
  "en-001": ["h", "hb", "H", "hB"],
  "FJ": ["h", "hb", "H", "hB"],
  "FM": ["h", "hb", "H", "hB"],
  "GD": ["h", "hb", "H", "hB"],
  "GM": ["h", "hb", "H", "hB"],
  "GU": ["h", "hb", "H", "hB"],
  "GY": ["h", "hb", "H", "hB"],
  "JM": ["h", "hb", "H", "hB"],
  "KI": ["h", "hb", "H", "hB"],
  "KN": ["h", "hb", "H", "hB"],
  "KY": ["h", "hb", "H", "hB"],
  "LC": ["h", "hb", "H", "hB"],
  "LR": ["h", "hb", "H", "hB"],
  "MH": ["h", "hb", "H", "hB"],
  "MP": ["h", "hb", "H", "hB"],
  "MW": ["h", "hb", "H", "hB"],
  "NZ": ["h", "hb", "H", "hB"],
  "SB": ["h", "hb", "H", "hB"],
  "SG": ["h", "hb", "H", "hB"],
  "SL": ["h", "hb", "H", "hB"],
  "SS": ["h", "hb", "H", "hB"],
  "SZ": ["h", "hb", "H", "hB"],
  "TC": ["h", "hb", "H", "hB"],
  "TT": ["h", "hb", "H", "hB"],
  "UM": ["h", "hb", "H", "hB"],
  "US": ["h", "hb", "H", "hB"],
  "VC": ["h", "hb", "H", "hB"],
  "VG": ["h", "hb", "H", "hB"],
  "VI": ["h", "hb", "H", "hB"],
  "ZM": ["h", "hb", "H", "hB"],
  "BO": ["H", "hB", "h", "hb"],
  "EC": ["H", "hB", "h", "hb"],
  "ES": ["H", "hB", "h", "hb"],
  "GQ": ["H", "hB", "h", "hb"],
  "PE": ["H", "hB", "h", "hb"],
  "AE": ["h", "hB", "hb", "H"],
  "ar-001": ["h", "hB", "hb", "H"],
  "BH": ["h", "hB", "hb", "H"],
  "DZ": ["h", "hB", "hb", "H"],
  "EG": ["h", "hB", "hb", "H"],
  "EH": ["h", "hB", "hb", "H"],
  "HK": ["h", "hB", "hb", "H"],
  "IQ": ["h", "hB", "hb", "H"],
  "JO": ["h", "hB", "hb", "H"],
  "KW": ["h", "hB", "hb", "H"],
  "LB": ["h", "hB", "hb", "H"],
  "LY": ["h", "hB", "hb", "H"],
  "MO": ["h", "hB", "hb", "H"],
  "MR": ["h", "hB", "hb", "H"],
  "OM": ["h", "hB", "hb", "H"],
  "PH": ["h", "hB", "hb", "H"],
  "PS": ["h", "hB", "hb", "H"],
  "QA": ["h", "hB", "hb", "H"],
  "SA": ["h", "hB", "hb", "H"],
  "SD": ["h", "hB", "hb", "H"],
  "SY": ["h", "hB", "hb", "H"],
  "TN": ["h", "hB", "hb", "H"],
  "YE": ["h", "hB", "hb", "H"],
  "AF": ["H", "hb", "hB", "h"],
  "LA": ["H", "hb", "hB", "h"],
  "CN": ["H", "hB", "hb", "h"],
  "LV": ["H", "hB", "hb", "h"],
  "TL": ["H", "hB", "hb", "h"],
  "zu-ZA": ["H", "hB", "hb", "h"],
  "CD": ["hB", "H"],
  "IR": ["hB", "H"],
  "hi-IN": ["hB", "h", "H"],
  "kn-IN": ["hB", "h", "H"],
  "ml-IN": ["hB", "h", "H"],
  "te-IN": ["hB", "h", "H"],
  "KH": ["hB", "h", "H", "hb"],
  "ta-IN": ["hB", "h", "hb", "H"],
  "BN": ["hb", "hB", "h", "H"],
  "MY": ["hb", "hB", "h", "H"],
  "ET": ["hB", "hb", "h", "H"],
  "gu-IN": ["hB", "hb", "h", "H"],
  "mr-IN": ["hB", "hb", "h", "H"],
  "pa-IN": ["hB", "hb", "h", "H"],
  "TW": ["hB", "hb", "h", "H"],
  "KE": ["hB", "hb", "H", "h"],
  "MM": ["hB", "hb", "H", "h"],
  "TZ": ["hB", "hb", "H", "h"],
  "UG": ["hB", "hb", "H", "h"]
};